import { ref, watch, Ref } from 'vue';

export const useSpinner = (deps: Ref<boolean>[]) => {
  const visible = ref<boolean>(false);
  let timeoutId: NodeJS.Timeout | undefined;

  watch(
    () => deps.map((dep) => dep.value),
    (value) => {
      if (value.some((dep) => dep)) {
        timeoutId = setTimeout(() => {
          visible.value = true;
        }, 500);
      } else {
        clearTimeout(timeoutId);
      }
    }
  );

  return {
    visible,
  }
}
